<div
  [ngClass]="
    isGridRender
      ? 'GridRender'
      : GridRenderForPackageConfiguration
      ? 'GridRenderForPackageConfiguration'
      : isSetWidth
      ? 'portlet light setPaddingGridProjectMaterial'
      : !isSetWidth && gridName === 'Project scenario list'
      ? ''
      : !isSetWidth && gridName === 'product-loss-grid'
      ? 'productMixGrid'
      : 'portlet light setPaddingGrid'
  "
>
  <div class="portlet-body">
    <div class="statusDrp">
      <div class="status-dropdown">
        <span *ngIf="showDropDown" class="filterIcon"><i class="bi bi-funnel"></i></span>
        <div *ngIf="showDropDown" class="filterDrp">
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            #status
            [items]="statusList"
            bindLabel="name"
            [searchable]="false"
            placeholder="Status"
            class="accordion-text addScroll"
            [(ngModel)]="selectedStatus"
            (change)="changeStatus($event)"
          >
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>
    <div [ngClass]="isInvoice ? 'row' : isProjectScreen ? '' : 'search-btn'">
      <div
        *ngIf="gridHeader"
        [ngClass]="isPreferenceScreen ? 'd-flex' : ''"
        class="col-md-12 datatable-l"
      >
        <div
          id="tblProjects_filter"
          [ngClass]="isPreferenceScreen ? 'custom-prefrnc-pad' : ''"
          class="dataTables_filter"
        >
          <label
            class="bootstrap-dialog-title d-inline-flex align-items-center"
            [ngClass]="{ 'header-text-crown-icon': isPremium }"
          >
            {{ gridHeader }}
            <app-crown-icon *ngIf="isPremium" [size]="20"></app-crown-icon>
            <span
              *ngIf="gridHeaderTooltip"
              class="ms-3 d-inline-flex align-items-center mb-1"
              placement="auto"
              tooltipClass="sku-tooltip"
              [ngbTooltip]="gridHeaderTooltip"
            >
              <a class="info-icon">
                <img
                  src="./assets/icons/grey-question-icon.svg"
                  width="16"
                  height="16"
                  alt="info"
                />
              </a>
            </span>
          </label>
        </div>
      </div>
      <div
        [ngClass]="
          !hideSearch && !isSearchInputPosition ? 'button-alignment' : 'validation-content'
        "
        [ngStyle]="{
          overflow: stepCount || stepTitle || stepText ? 'auto' : 'hidden'
        }"
      >
        <div
          class="datatable-l"
          [ngClass]="!hideSearch && !isSearchInputPosition ? 'col-md-3' : 'col-md-9'"
        >
          <div
            class="services-form-second"
            [ngClass]="searchInputSize ? 'searchInputSizeFillData' : 'dataTables_filter'"
            *ngIf="!hideSearch"
            id="tblProjects_filter"
          >
            <input
              type="text"
              class="form-control input-sm"
              aria-controls="tblProjects"
              [formControl]="searchControl"
              (input)="callFilter($event)"
              #searchFilter
            />
            <!-- <label class="search-margin">Search...</label> -->
            <span class="searchIcon" *ngIf="!isShowClearIcon">
              <i class="fa fa-search icon"></i>
            </span>
            <span *ngIf="isShowClearIcon" (click)="clearSearchBox()" class="searchIcon">
              <i class="fa fa-close icon"></i>
            </span>
          </div>
        </div>

        <div
          [ngClass]="gridName === 'addSKUdata' ? 'notificationSKU' : 'notificationNew'"
          *ngIf="showNotification && error && !showUserNotification"
        >
          <span>{{ error }}</span>
        </div>

        <div
          *ngIf="stepCount || stepTitle || stepText"
          [joyrideStep]="stepCount ? stepCount : 'step_temp'"
          (next)="onNext()"
          (prev)="onPrev()"
          [title]="stepTitle"
          [text]="stepText"
          [stepPosition]="stepPos ? stepPos : 'bottom'"
        >
          <ng-container *ngTemplateOutlet="createButtonTemplate"></ng-container>
        </div>

        <div *ngIf="!stepCount && !stepTitle && !stepText && !headerBtn?.includes('row')">
          <ng-container *ngTemplateOutlet="createButtonTemplate"></ng-container>
        </div>
      </div>
    </div>
    <piqet-angular-incorrect-data-notification
      *ngIf="showNotification && error && showUserNotification"
      [message]="error"
      [buttonName]="buttonName"
      [isShowButton]="true"
      [componentName]="gridName"
      (eolAction)="handleIncorrectDataAction()"
    ></piqet-angular-incorrect-data-notification>
    <div [ngClass]="!isPreferenceScreen ? 'row' : ''">
      <piqet-angular-ag-grid
        [class]="class"
        [stepCountAg]="stepCountGrid"
        [stepTitleAg]="stepTitleGrid"
        [isServerSide]="isServerSide"
        [totalCount]="totalCount"
        [stepTextAg]="stepTextGrid"
        [stepPositionAg]="stepPositionGrid"
        (guidedTourGridEvent)="onNext()"
        (guidedTourGridPrevEvent)="onPrev()"
        [frameworkComponents]="frameworkComponents"
        [isCheckOrganization]="isCheckOrganization"
        [ngClass]="isSetWidth ? 'setPadding' : ''"
        [hidePagination]="hidePagination"
        [gridData]="gridDataReplica"
        [pageNo]="pageNo"
        [headerBtnName]="headerBtnName"
        (paginationChangeEvent)="paginationChangeEvent.emit($event)"
        (changeRowOrder)="changeRowOrder.emit($event)"
        (sortChangeEvent)="sortChangeEvent.emit($event)"
        (editDataEvent)="editDataEvent.emit()"
        (inlineDataEditEvent)="inlineDataEditEvent.emit($event)"
        [columnDefs]="columnDefs"
        [autoGroupColumnDef]="autoGroupColumnDef"
        [hideSideBar]="hideSideBar"
        [gridName]="gridName"
        [context]="context"
        [gridConfig]="gridConfig"
        [inlineEdit]="inlineEdit"
        [isChekIniline]="isChekIniline"
        [supressPagination]="supressPagination"
        [isEOLGrid]="isEOLGrid"
        [isInlineGrid]="isInlineGrid"
        [treeData]="treeData"
        [isAnimateRows]="isAnimateRows"
        #grid
      ></piqet-angular-ag-grid>
    </div>

    <div *ngIf="!stepCount && !stepTitle && !stepText && headerBtn?.includes('row')">
      <ng-container *ngTemplateOutlet="addRowTemplate"></ng-container>
    </div>
  </div>
</div>

<ng-template #createButtonTemplate>
  <div class="datatable-r" *ngIf="headerBtn && createAccess">
    <div *ngIf="importProjectNew" class="DTTT_container">
      <div
        class="DTTT_button mb-1 ms-2"
        id="ToolTables_tblProjects_0"
        [ngClass]="disableButton ? 'disabledbluehoki' : ''"
        tabindex="0"
        aria-controls="tblProjects"
      >
        <button
          [innerHTML]="importProjectNew"
          (click)="
            headerBtn?.includes('fa fa-plus') ? createCustomConversion() : openImportModal.emit()
          "
          [ngClass]="headerBtn?.includes('fa fa-plus') ? 'portletBtn' : 'btnText'"
        ></button>
      </div>
    </div>
    <div *ngIf="downloadOrganizationTemplate" class="DTTT_container">
      <div
        class="DTTT_button mb-1 ms-2"
        id="ToolTables_tblProjects_0"
        [ngClass]="disableButton ? 'disabledbluehoki' : ''"
        tabindex="0"
        aria-controls="tblProjects"
      >
        <button
          [innerHTML]="downloadOrganizationTemplate"
          (click)="downloadOrganizationTemplateFunc()"
          [ngClass]="
            headerBtn?.includes('fa fa-plus') ? 'portletBtn' : 'btnText email-download-btn'
          "
        ></button>
      </div>
    </div>
    <div *ngIf="addMappingData" class="DTTT_container">
      <div
        class="DTTT_button mb-1 ms-2"
        id="ToolTables_tblProjects_0"
        [ngClass]="disableButton ? 'disabledbluehoki' : ''"
        tabindex="0"
        aria-controls="tblProjects"
      >
        <button
          [innerHTML]="addMappingData"
          (click)="
            headerBtn?.includes('fa fa-plus')
              ? createCustomConversion()
              : openAddMappingModal.emit()
          "
          [ngClass]="headerBtn?.includes('fa fa-plus') ? 'portletBtn' : 'btnText add-map-btn'"
        ></button>
      </div>
    </div>

    <div *ngIf="adminCopyOrganization" class="DTTT_container">
      <div
        class="DTTT_button mb-1 ms-2"
        id="ToolTables_tblProjects_0"
        [ngClass]="disableButton ? 'disabledbluehoki' : ''"
        tabindex="0"
        aria-controls="tblProjects"
      >
        <button
          [innerHTML]="adminCopyOrganization"
          (click)="openAdminCopyOrganization.emit()"
          [ngClass]="headerBtn?.includes('fa fa-plus') ? 'portletBtn' : 'btnText'"
        ></button>
      </div>
    </div>

    <div *ngIf="testAutomation" class="DTTT_container">
      <div
        class="DTTT_button mb-1 ms-2"
        id="ToolTables_tblProjects_0"
        [ngClass]="disableButton ? 'disabledbluehoki' : ''"
        tabindex="0"
        aria-controls="tblProjects"
      >
        <button
          [innerHTML]="testAutomation"
          (click)="openTestAutomation.emit()"
          [ngClass]="headerBtn?.includes('fa fa-plus') ? 'portletBtn' : 'btnText'"
        ></button>
      </div>
    </div>

    <div *ngIf="importProject" class="DTTT_container">
      <div
        class="DTTT_button mb-1 ms-2"
        id="ToolTables_tblProjects_0"
        [ngClass]="disableButton ? 'disabledbluehoki' : ''"
        tabindex="0"
        aria-controls="tblProjects"
      >
        <button
          [innerHTML]="importProject"
          (click)="
            headerBtn?.includes('fa fa-plus') ? createCustomConversion() : openImportModal.emit()
          "
          [ngClass]="headerBtn?.includes('fa fa-plus') ? 'portletBtn' : 'btnText'"
        ></button>
      </div>
    </div>
    <div *ngIf="downloadImportTemplate" class="DTTT_container">
      <div
        class="DTTT_button mb-1 ms-2"
        id="ToolTables_tblProjects_0"
        [ngClass]="disableButton ? 'disabledbluehoki' : ''"
        tabindex="0"
        aria-controls="tblProjects"
      >
        <button
          [innerHTML]="downloadImportTemplate"
          (click)="downloadTemplate()"
          [ngClass]="headerBtn?.includes('fa fa-plus') ? 'portletBtn' : 'btnText'"
        ></button>
      </div>
    </div>

    <div *ngIf="addNewOrgMap" class="DTTT_container">
      <div
        class="DTTT_button mb-1 ms-2"
        id="ToolTables_tblProjects_0"
        [ngClass]="disableButton ? 'disabledbluehoki' : ''"
        tabindex="0"
        aria-controls="tblProjects"
      >
        <button
          [innerHTML]="addNewOrgMap"
          (click)="addOrgMap()"
          [ngClass]="
            headerBtn?.includes('fa fa-plus') ? 'portletBtn' : 'btnText email-download-btn'
          "
        ></button>
      </div>
    </div>

    <div *ngIf="importExcel" class="DTTT_container">
      <div
        class="DTTT_button mb-1 ms-2"
        id="ToolTables_tblProjects_0"
        [ngClass]="disableButton ? 'disabledbluehoki' : ''"
        tabindex="0"
        aria-controls="tblProjects"
      >
        <button
          [innerHTML]="importExcel"
          (click)="importExcelTemplates()"
          [ngClass]="headerBtn?.includes('fa fa-plus') ? 'portletBtn' : 'btnText'"
        ></button>
      </div>
    </div>

    <div *ngIf="importBtn" class="DTTT_container">
      <div
        class="DTTT_button mb-1 ms-2"
        id="ToolTables_tblProjects_0"
        [ngClass]="disableButton ? 'disabledbluehoki' : ''"
        tabindex="0"
        aria-controls="tblProjects"
      >
        <button
          [innerHTML]="importBtn"
          (click)="redirectToImportExcel()"
          [ngClass]="headerBtn?.includes('fa fa-plus') ? 'portletBtn' : 'btnText'"
        ></button>
      </div>
    </div>

    <div *ngIf="importRefresh" class="DTTT_container">
      <div
        class="DTTT_button mb-1 ms-2"
        id="ToolTables_tblProjects_0"
        [ngClass]="disableButton ? 'disabledbluehoki' : ''"
        tabindex="0"
        aria-controls="tblProjects"
      >
        <button
          [innerHTML]="importRefresh"
          (click)="refreshImportData()"
          [ngClass]="headerBtn?.includes('fa fa-plus') ? 'portletBtn' : 'btnText'"
        ></button>
      </div>
    </div>

    <div class="DTTT_container" style="margin-right: 0px">
      <div
        class="DTTT_button"
        id="ToolTables_tblProjects_0"
        tabindex="0"
        aria-controls="tblProjects"
      >
        <button
          [disabled]="disableButton"
          [innerHTML]="headerBtn"
          (click)="
            headerBtn?.includes('fa fa-plus') ? createCustomConversion() : openBtnModal.emit();
            clearSearchBox()
          "
          (mouseenter)="headerBtn.includes('fa fa-plus') && changeImageOnHover(true)"
          (mouseleave)="headerBtn.includes('fa fa-plus') && changeImageOnHover(false)"
          [ngClass]="
            headerBtn.includes('fa fa-plus') && disableButton
              ? 'plusBtnDisable'
              : headerBtn.includes('fa fa-plus')
              ? 'portletBtn'
              : 'btnText'
          "
        ></button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #addRowTemplate>
  <div class="DTTT_container" *ngIf="headerBtn && createAccess">
    <div
      class="add-row-align"
      id="ToolTables_tblProjects_0"
      tabindex="0"
      aria-controls="tblProjects"
    >
      <button
        class="add-row purpleBtnHoverEffect"
        [ngClass]="disableButton ? 'disabled-add-row' : ''"
        [disabled]="disableButton"
        [innerHTML]="headerBtn"
        (click)="createCustomConversion(); clearSearchBox()"
      ></button>
    </div>
  </div>
</ng-template>
